<template>
  <div class="about-area">
    <div class="container">
      <!-- Trending Tittle -->
      <div class="row">
        <div class="col-lg-12">
          <div class="trending-tittle"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8">
          <!-- Trending Tittle -->
          <div class="about-right mb-90">
            <div class="about-img">
              <img src="@/assets/images/838b4325c8a132ff6bb0.jpg" alt="" />
            </div>
            <div class="section-tittle mb-30 pt-30">
              <h3 style="text-align: center;">GIỚI THIỆU CHUNG VỀ CÔNG TY</h3>
            </div>
            <div class="about-prea" style="text-align: justify;">
              <p class="about-pera1">
                Công ty Đấu giá hợp danh Số 5 - Quốc gia, Giấy đăng ký hoạt động của doanh nghiệp đấu giá tài sản số
                45/TP-ĐKHĐ do Sở tư pháp thành phố Hà Nội cấp ngày 21/02/2019 (tiền thân là Công ty cổ phần Đấu giá Số 5
                – Quốc gia, chuyển đổi mô hình hoạt động theo yêu cầu của Luật đấu giá tài sản 2016). Một số thông tin
                cơ bản về Công ty Đấu giá Hợp danh Số 5 - Quốc gia như sau:
              </p>
              <p class="about-pera1">- Tên công ty: CÔNG TY ĐẤU GIÁ HỢP DANH SỐ 5 – QUỐC GIA</p>
              <p class="about-pera1">
                - Trụ sở chính: số 193 Hoàng Văn Thái, phường Khương Trung, quận Thanh Xuân, thành phố Hà Nội, Việt Nam.
              </p>
              <p class="about-pera1">- Điện thoại: 024.37622620; 024.37622619</p>
              <p class="about-pera1">
                - Người đại diện theo pháp luật: Thạc sỹ, Luật sư Quản Văn Minh – Chức vụ: Tổng giám đốc.
              </p>
              <p class="about-pera1">
                Công ty Đấu giá Hợp danh Số 5 – Quốc gia là thành viên thuộc NALAF GROUP – là hệ thống các tổ chức hoạt
                động dịch vụ pháp luật, bao gồm nhiều mảng hoạt động lớn như: lĩnh vực luật sư, đấu giá tài sản, quản lý
                & thanh lý tài sản (quản tài viên), Trọng tài thương mại, … Công ty Đấu giá hợp danh Số 5 - Quốc gia
                được thành lập trên nền tảng nhân sự là các luật sư, chuyên gia pháp lý có uy tín, bề dầy kinh nghiệm
                trong hoạt động pháp lý.
              </p>
              <p>
                Năng lực nhân sự, trình độ và chất lượng nhân sự chuyên môn nghiệp vụ đấu giá là thế mạnh lớn của Công
                ty Đấu giá Hợp danh Số 5- Quốc gia. Công ty có đội ngũ nhân sự chuyên nghiệp, gồm 12 đấu giá viên có bề
                dày kinh nghiệm và uy tín, có trình độ nghiệp vụ cao (09/12 đấu giá viên của công ty là Luật sư có uy
                tín hoạt động nhiều năm kinh nghiệm, kể từ khi Nghị định 17/2010/NĐ-CP, 01 đấu giá viên là Tiến sỹ Luật
                học) và Người đại diện theo pháp luật của Tổ chức đấu giá tài sản là: Thạc sỹ, Luật sư Quản Văn Minh–
                Đấu giá viên (CCHN số 409/TP/ĐG-CCHN do Bộ Tư pháp cấp ngày 09/8/2011), hiện ông Minh là Chủ tịch Hội
                đấu giá viên thành phố Hà Nội, đồng thời là Uỷ viên Ban Thường vụ Trung ương Hội Luật gia Việt Nam, và
                là một luật sư hơn 20 năm kinh nghiệm và uy tín, trình độ am hiểu pháp luật. Trước đây, ông Quản Văn
                Minh còn là Thành viên Ban soạn thảo Dự án Luật đấu giá tài sản năm 2016, có uy tín và trình độ nghiệp
                vụ hiểu biết pháp luật, điều hành hoạt động hành nghề đấu giá tài sản tuân thủ đúng quy định pháp luật,
                chuyên nghiệp theo đúng hành lang pháp lý và cơ chế minh bạch, khách quan. Đối với bộ phận công nghệ
                thông tin, tất cả các cán bộ điều hành hệ thống kỹ thuật, quản trị hệ thống đều là các cán bộ có trình
                độ đại học về Công nghệ thông tin, bảo đảm hệ thống phải có khả năng tiếp thu chuyển giao công nghệ về
                kỹ thuật và hệ thống ứng dụng, hiểu rõ thiết kế hệ thống, quản lý về kỹ thuật mạng và truyền thông, sửa
                chữa và bảo dưỡng thiết bị, quản trị mạng.
              </p>
              <p>
                Kể từ khi thành lập đến nay, Công ty Đấu giá hợp danh Số 5 - Quốc gia đã đạt nhiều thành công lớn, khẳng
                định vị trí của tổ chức đấu giá tài sản chuyên nghiệp, có bề dày kinh nghiệm tổ chức đấu giá tài sản và
                uy tín nghề nghiệp trong cả nước. Công ty vinh dự nhận nhiều Bằng khen, giấy khen của Thành phố (các năm
                liên tiếp là Tổ chức đấu giá tài sản được nhận Bằng khen của Chủ tịch UBND Thành phố Hà Nội: năm 2014,
                2015, 2016; ngoài ra còn Giấy khen, Phần thưởng thành tích của các UBND cấp quận huyện địa phương nơi có
                tài sản đấu giá.
              </p>
              <p>
                Phương án tổ chức và kế hoạch tổ chức đấu giá được thực hiện tuân thủ theo các quy định của pháp luật về
                đấu giá tài sản và các văn bản pháp luật chuyên ngành áp dụng đối với từng loại đối tượng tài sản bán
                đấu giá khác nhau.
              </p>
              <p>
                Công ty có uy tín, kinh nghiệm trong công tác tổ chức đấu giá đối với nhiều loại tài sản khác nhau, có
                thể kể đến như:
              </p>
              <p>
                - Đối với công tác đấu giá quyền sử dụng đất để giao đất có thu tiền sử dụng đất hoặc cho thuê đất của
                Nhà nước: Công ty đã ký kết hàng trăm hợp đồng bán đấu giá và triển khai tổ chức thực hiện bán đấu giá
                quyền sử dụng đất trên địa bàn hơn 20 quận, huyện của thành phố Hà Nội (ví dụ như: Cầu Giấy, Đống Đa,
                Long Biên, Tây Hồ, Hoàng Mai, Hà Đông, Đông Anh, Nam Từ Liêm, Thường Tín, Thanh Trì, Sóc Sơn, Gia Lâm,
                Thanh Oai, Mê Linh, Mỹ Đức, Phú Xuyên, Thường Tín, Quốc Oai …). Ngoài ra, Công ty còn tổ chức đấu giá
                tại nhiều tỉnh thành khác như: Tuyên Quang, Hải Dương, Phú Thọ, Thanh Hóa, Quảng Ninh, Nam Định, ...
              </p>
              <p>
                - Đối với công tác đấu giá tài sản bảo đảm, tài sản VAMC: Công ty nhiều năm liền được lựa chọn là đơn vị
                tổ chức bán đấu giá tài sản cho Công ty quản lý tài sản VAMC (theo các quyết định Quyết định số
                624/BB&XLN-VAMC ngày 03/6/2016 và số 907/BB&XLN-VAMC ngày 01/8/2017). Đồng thời công ty đã và đang triển
                khai hàng loạt hợp đồng dịch vụ đấu giá tài sản bảo đảm các Ngân hàng trên cả nước.
              </p>
              <p>
                - Đối với công tác đấu giá quyền khai thác khoáng sản: Công ty đã thực hiện đấu giá thành công đối với
                Quyền khai thác khoáng sản do Hội đồng đấu giá quyền khai thác khoáng sản Bộ Tài nguyên môi trường ủy
                quyền như: quyền khai thác khoáng sản quặng sắt khu vực Nam Phia Đăm, xã Bằng Thành và xã Bộc Bố, huyện
                Pác Nặm, tỉnh Bắc Kạn; khoáng sản quặng apatit khai trường 19b, xã Đổng Tuyển, thành phố Lào Cai, tỉnh
                Lào Cai; quyền khai thác khoáng sản cát trắng khu vực Cây Táo 3, xã Hồng Liêm, huyện Hàm Thuận Bắc, tỉnh
                Bình Thuận; khoáng sản đá trang trí mỹ nghệ khu vực Suối Giàng 1, xã Suối Giàng, huyện Văn Chấn, tỉnh
                Yên Bái, ...
              </p>
              <p>
                - Đối với công tác đấu giá tài sản là các cơ sở sản xuất, dự án: Công ty đã thực hiện bán đấu giá thành
                công đối với các cơ sở nhà đất, dự án lớn cho các đối tác là Tổng công ty cổ phần Xuất nhập khẩu & xây
                dựng Việt Nam (Vinaconex JSC) – Công ty CP SGD BĐG Vinaconex (Tổng giá trị tài sản bán đấu giá thành là:
                87.208.000.000 đồng (Bằng chữ: Tám mươi bẩy tỷ, hai trăm linh tám triệu đồng chẵn); Công ty cổ phần Thực
                Phẩm Hữu Nghị 37.500.000.000 đồng (Ba mươi bảy tỷ năm trăm triệu đồng chẵn); …
              </p>
              <p>
                - Đối với công tác đấu giá tài sản là cổ vật, tác phẩm nghệ thuật: Công ty CP Đấu giá Số 5 – Quốc gia là
                Tổ chức bán đấu giá chuyên nghiệp đầu tiên được UBND TP Hà Nội cấp Giấy phép về việc tổ chức bán đấu giá
                cổ vật theo quy định pháp luật tại Văn bản số 3110/UBND-KGVX ngày 27/6/2017 của UBND TP Hà Nội, khẳng
                định tính pháp lý của hồ sơ tài sản cổ vật đã được đăng ký tại Ngân hàng nhà nước có thẩm quyền, quy
                trình thủ tục thực hiện bán đấu giá tuân thủ quy định pháp luật, và đặc biệt cuộc bán đấu giá có ý nghĩa
                giá trị lớn tôn vinh văn hóa, truyền thống, di sản văn hóa của dân tộc.
              </p>
              <p>
                - Đối với công tác tổ chức đấu giá bằng hình thức trực tuyến: Ngày 12/5/2020, Sở Tư pháp thành phố Hà
                Nội đã chính thức ban hành Quyết định số 112/QĐ-STP về việc phê duyệt tổ chức đấu giá tài sản đủ điều
                kiện thực hiện hình thức đấu giá trực tuyến. Như vậy, Công ty Đấu giá Hợp danh Số 5 – Quốc gia trở thành
                tổ chức đấu giá tài sản đầu tiên trên cả nước được cơ quan có thẩm quyền phê duyệt đủ điều kiện thực
                hiện hình thức đấu giá trực tuyến theo quy định tại Luật đấu giá tài sản 2016.
              </p>
              <p>
                Công ty Đấu giá Hợp danh Số 5 – Quốc gia cam kết đáp ứng đầy đủ các điều kiện cần và đủ về đội ngũ nhân
                sự có trình độ nghiệp vụ, chuyên nghiệp và hệ thống hạ tầng kỹ thuật để thực hiện đấu giá trực tuyến,
                cùng với phương án, giải pháp kỹ thuật bảo đảm vận hành an toàn hệ thống kỹ thuật Trang thông tin điện
                tử đấu giá trực tuyến. Với bề dày kinh nghiệm và uy tín đã được tích lũy trong thời gian qua, chúng tôi
                tin tưởng sẽ luôn đồng hành cùng khách hàng để vượt qua khó khăn, nắm bắt cơ hội để cùng nhau xây dựng
                một thị trường đấu giá tài sản công khai, minh bạch và phát triển bền vững.
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4"></div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixins/mixin.js';
export default {
  name: 'About',
  mixins: [mixin],
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/About.vue